module.exports = __webpack_public_path__ + "static/media/jokeri_vaunu_background.e26529c2.jpg";